<template>
  <div id="admin-dashboard">
    <b-card no-body class="py-2 container-card mb-1 bg-status-document">
      <b-row class="px-1">
        <b-col cols="12" class="mb-1 text-center">
          <b-row>
            <b-col>
              <div class="d-flex justify-content-start align-items-center">
                <span
                  ><img
                    src="https://media.discordapp.net/attachments/887366626561904641/940836626702147594/Group_28226.png"
                    alt=""
                    class="image-summary mr-2"
                /></span>
                <span class="font-medium-5 font-weight text-header">Admin</span>
              </div>
            </b-col>
          </b-row>
          <b-row >
            <b-col class="">
              <div class="scrollbar mt-2">
                <div class="text-left" v-for="admin in adminObj.admin.payload" :key="admin.id">
                  <div class="admin-wrp">
                    <span class="icon-document">
                      <document />
                    </span>
                    <span class="font-white value-admin">{{admin.value}}</span>
                  </div>
                  <div class="text-black name-admin font-medium-5">{{ admin.name || "ไม่ระบุชื่อ" }}</div>
                  <div>Updated. {{ admin.update_time }}</div>
                  <div class="line-list-admin mb-1"></div>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import Document from "@/@core/components/svg/nav-bar/Document.vue";

export default {
props: { adminObj: Object, default: {} },
setup() {
    return {};
  },

  components: { Document },
};
</script>

<style>
</style>